<template>
    <el-dialog title="附件列表" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="noticeBox">
            <div class="fileDown" v-for="file in list" :key="'fi'+file.id">
                <el-image class="icon" :src="imgServer+'/static'+file.icon"></el-image>
                <div class="ftitleBox">
                    <div class="title">{{file.title}}</div>
                    <div class="ftitle" style="margin-top:4px">{{file.file_size}}</div>
                </div>
                <el-button type="primary" plain size="mini" class="downBtn" @click="downFile(file.file_path)">下载</el-button>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { workHoleAnnexList } from '@/api/annex'
import config from "@/config/index"

export default {
    name: 'workHoleAnnexList',
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        data_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.getAnnexList()
            }
        }
    },
    data() {
        return {
            showflag: false,
            enu_name: [],
            list: [],
            imgServer: config.imgServer,
        };
    },
    methods: {
        getAnnexList(){
            this.list = [];
            workHoleAnnexList(this.data_id).then(res=>{
                if(res.code ==1){
                    this.list = res.data
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        closeDialog(){
            this.$emit("on-close")
        },
        downFile(url){
            let cos_domain = localStorage.getItem("cos_domain")
            if(url.indexOf("#")>=0){
                url = url.replaceAll("#", "%23")
            }
            window.open(cos_domain+url)
        },
    }
};
</script>

<style lang="less" scoped>
    .noticeBox {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        .fileDown {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            font-size: 16px;
            color: #909399;
            margin-bottom: 20px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            padding: 10px;
            box-sizing: border-box;
            border-radius: 6px;
            position: relative;
            .icon {
                width: 52px;
                height: 52px;
            }
            .ftitleBox {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                margin-left: 8px;
                .title{
                    color: #303133;
                    font-size: 14px;
                }
                .ftitle {
                    font-size: 12px;
                }
            }
            .downBtn {
                position: absolute;
                right: 20px;
            }
            .downBtn1 {
                position: absolute;
                right: 90px;
            }
        }
    }
</style>
